import { gql } from '@apollo/client'

export const CreateProductFlagForReviewMutation = gql`
    mutation createProductListingFlagForReview(
        $projectId: String!
        $listingId: String!
        $isFromRevit: Boolean
    ) {
        createProductListingFlagForReview(
            projectId: $projectId
            listingId: $listingId
            isFromRevit: $isFromRevit
        ) {
            message
            items {
                projectId
                listingId
            }
        }
    }
`

export const RemoveProductFlagForReviewMutation = gql`
    mutation removeProductListingFlagForReviewByListingId(
        $projectId: String!
        $listingId: String!
    ) {
        removeProductListingFlagForReviewByListingId(
            projectId: $projectId
            listingId: $listingId
        ) {
            message
            items {
                projectId
                listingId
            }
        }
    }
`
